var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x-circle_svg__clip0_1405_9975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6l-4 4m0-4l4 4m4.667-2A6.667 6.667 0 111.333 8a6.667 6.667 0 0113.334 0z",
    stroke: "#476FF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "x-circle_svg__clip0_1405_9975"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24gLyB4LWNpcmNsZSIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0MDVfOTk3NSkiPgo8cGF0aCBpZD0iSWNvbiIgZD0iTTkuOTk5OTIgNi4wMDAxTDUuOTk5OTIgMTAuMDAwMU01Ljk5OTkyIDYuMDAwMUw5Ljk5OTkyIDEwLjAwMDFNMTQuNjY2NiA4LjAwMDFDMTQuNjY2NiAxMS42ODIgMTEuNjgxOCAxNC42NjY4IDcuOTk5OTIgMTQuNjY2OEM0LjMxODAyIDE0LjY2NjggMS4zMzMyNSAxMS42ODIgMS4zMzMyNSA4LjAwMDFDMS4zMzMyNSA0LjMxODIgNC4zMTgwMiAxLjMzMzQ0IDcuOTk5OTIgMS4zMzM0NEMxMS42ODE4IDEuMzMzNDQgMTQuNjY2NiA0LjMxODIgMTQuNjY2NiA4LjAwMDFaIiBzdHJva2U9IiM0NzZGRjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE0MDVfOTk3NSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgXCircle as ReactComponent };